<template>
  <div class="third-step-box">
    <div class="form">
      <!--您是否愿意提供一定数量的代币用于运营活动及市场推广，以便扩大该币的影响力呢？-->
      <div class="form-item">
        <p class="label required-fields">{{$t('8000164')}}</p>
        <van-radio-group v-model="thirdTemp.isTokenWillingness" @change="changeRadio">
          <van-radio name="1">
            <template #icon="props">
              <svg-icon :icon-class="props.checked ? 'xuanzhong2' : 'moren1'"/>
            </template>{{$t('8000169')}}</van-radio>
          <van-field type="textarea" rows="1" autosize class="value" :class="{errorClass: !!emailLimitMsg}" v-if="thirdTemp.isTokenWillingness == 1" @focus="emailLimitMsg = ''" @blur="handleEmailBlur" v-model="thirdTemp.email" clearable autocomplete="off" :placeholder="$t('8000170')"/>
          <span class="error-msg-style" v-if="emailLimitMsg">{{ emailLimitMsg }}</span>
          <van-radio name="0">
            <template #icon="props">
              <svg-icon :icon-class="props.checked ? 'xuanzhong2' : 'moren1'"/>
            </template>
            {{$t('8000168')}}</van-radio>
        </van-radio-group>
      </div>
      <!--您是否有推荐人或对接人？-->
      <div class="form-item">
        <p class="label">{{$t('8000171')}}</p>
        <van-field type="textarea" rows="1" autosize class="value" maxlength="50" v-model="thirdTemp.referral" clearable autocomplete="off" :placeholder="$t('8000172')"/>
      </div>
      <div class="tip-message-box">
        <h2 class="bold title">{{$t('300166')}}：</h2>
        <!--
        1. 上币者需要自己对信息真实性负责，并且平台有权利随时下架币种或交易对，平台有权利随时调整信息内容。',
        2. 上币者需要对所上币种进行充分调研，并对其的合理、合规和合法性负责。如果平台发现币种的智能合约有各种恶意的或者伤害性的行为，会直接将其下架，并代表用户对上币者进行索赔。',
        3. 上币者或者其他人如果之后想对币种信息做调整，需要联系我们的客服。',
        4. 为了保护用户的利益和淘汰不良币种，上币者创建的交易对如果不符合我们平台的成交量的要求标准，就会在约一周后的时间被通知下架。每周一的时候，平台会对不符合的交易对发出下架通知，届时上币者在3天内还有机会可以对其申请延迟下架。 如果申请延迟下架成功，会获得额外4周的上架观察时间，否则就会被下架。',
        5. 上币者创建的交易对副本如果其交易额满足了平台的分红标准门槛，将会收到对应的手续费分红。
        6. 上币者可以联系平台客服申请做市商的资格。
        -->
        <p>{{$t('8000159')}}</p>
        <p>{{$t('8000160')}}</p>
        <p>{{$t('8000161')}}</p>
        <p>{{$t('8000162')}} </p>
        <p>{{$t('8000163')}}</p>
        <p>{{$t('8000165')}}</p>
      </div>
    </div>
    <div class="form-buttons-box">
      <van-button class="back-btn" @click="handleBack">{{ $t('10000012') }}</van-button>
      <van-button class="next-btn" @click="nextStep" :loading="submitButtonLoading" :disabled="!!emailLimitMsg">{{ $t('8000166') }}</van-button>
    </div>
    <van-popup v-model="createModel" closeable close-icon="cross" close-icon-position="top-right">
      <div class="create-tip-msg">
        <svg class="icon" aria-hidden="true" :class="isDirection ? 'mirrorRotateLevel' : ''"><use xlink:href="#icon-Vector5"></use></svg>
        <p>{{$t('8000167',{currency: `${$parent.currency}/USDT-${$parent.memo}`,upFee: $parent.upFee})}}</p>
        <div class="service">
          <svg @click="checked = !checked" class="icon pointer checkIcon" aria-hidden="true">
            <use :xlink:href="!checked ? '#icon-weixuanzhong' : '#icon-xuanzhong'"></use>
          </svg>
          &nbsp;
          <!--勾选此框,表明您愿意承担所有相关风险,并同意我们的 <a href="" target="">《条款和条件》</a>-->
          <div class="inline-block" ref="content" v-html="$t('8000173')"></div>
        </div>
        <van-button @click="handleSure" :loading="$parent.createSubmitStatus" :disabled="!checked">{{ $t('8000129') }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {RadioGroup,Radio,Field,Button,Popup} from "vant";
export default {
  name: "thirdStep",
  components: {
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanField: Field,
    vanButton: Button,
    vanPopup: Popup
  },
  data() {
    return {
      submitButtonLoading: false,
      createModel: false,
      thirdTemp: {
        isTokenWillingness: '0',
        referral: '',
        email: ''
      },
      emailLimitMsg: '',
      checked: false,
      serviceHref: {
        'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/4413122414105-%E7%94%A8%E6%88%B6%E5%8D%94%E8%AD%B0?_gl=1%2Avj210%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM4NDQ0LjAuMC4w',
        en: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        es: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        fa: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        fr: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        ja: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        kr: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        ru: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        uk: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
        vi: 'https://support.superex.com/hc/en-001/articles/11479008598553-User-Agreement?_gl=1%2Aeuc0ib%2A_ga%2AMTkzMDI3MjQyNC4xNzEzNDMxNTk1%2A_ga_W94SCVN3FF%2AMTcyNTkzODQxMy4xODcuMS4xNzI1OTM5NzM0LjAuMC4w',
      }
    }
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  methods: {
    handleBack() {
      this.$emit('handlePrev', 2)
    },
    handleClick() {
      if (this.$parent.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goBrowser, {code: 200, link: this.serviceHref[this.$parent.language]}, (data) => {})
      } else {
        window.location.href = this.serviceHref[this.$parent.language]
      }
    },
    changeRadio() {
      this.thirdTemp.email = ''
    },
    nextStep() {
      this.createModel = true
      this.$nextTick(() => {
        const serviceHrefId = document.getElementById('service_href')
        if (serviceHrefId) {
          serviceHrefId.addEventListener('click', this.handleClick);
        }
      })
      /*setTimeout(() => {
        const href = this.serviceHref[this.language]
        const serviceHrefId = document.getElementById('service_href')
        console.log(serviceHrefId,href)
        serviceHrefId.href = href
      }, 100)*/
    },
    handleEmailBlur(event) {
      const reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      // console.log(!reg.test(event.target._value))
      if (event.target._value != '' && !reg.test(event.target._value)){
        this.emailLimitMsg = this.$t('8000142')
      }else {
        this.emailLimitMsg = ''
      }
    },
    handleSure() {
      this.createModel = false
      this.$emit('handleNextStep', 4)
    }
  },
  beforeDestroy() {
    const serviceHrefId = document.getElementById('service_href')
    if (serviceHrefId) {
      serviceHrefId.addEventListener('click', this.handleClick);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/mixin";
@import "../../../assets/css/variableName";
@import "../public";
.third-step-box{
  padding: torem(16) torem(16) torem(100);
  /deep/ .van-radio__icon{
    line-height: torem(14);
  }
  .svg-icon{
    width: torem(16);
    height: torem(16);
  }
  /deep/ .van-radio__label{
    font-size: torem(14);
    line-height: 1.5;
    color: #7F8490;
    margin: 0 torem(4);
  }
  /deep/ .van-radio__icon--checked+.van-radio__label{
    color: #FFC72B;
  }
  /deep/ .van-icon-success:before{
    content: '';
    display: inline-block;
    width: torem(8);
    height: torem(8);
    background: #FFC72B;
    border-radius: 50%;
  }
  /deep/ .van-radio{
    margin: torem(8) 0;
    &:first-child{
      margin-top: 0;
    }
  }
  .tip-message-box{
    background: #F9F9F9;
    padding: torem(16);
    border-radius: torem(8);
    h2.title {
      font-size: torem(14);
      font-weight: 600;
      color: #000922;
      margin-bottom: torem(16);
    }
    p{
      line-height: 1.4;
      margin-bottom: torem(20);
      font-size: torem(14);
      color: #40475A;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
/deep/ .van-popup__close-icon {
  color: #000922;
  font-size: torem(16);
}
/deep/ .van-popup{
  border-radius: torem(8);
}
.create-tip-msg{
  width: torem(340);
  padding: torem(24) torem(16);
  text-align: center;
  .icon{
    width: torem(48);
    height: torem(48);
    margin: 0 auto;
  }
  p{
    color: #000922;
    text-align: center;
    font-size: torem(14);
    line-height: 1.5;
    margin: torem(16) 0;
  }
  /deep/ .van-button--disabled{
    background-color: rgba(0, 0, 0, 0.10) !important;
    color: #7F8490;
    opacity: 1;
  }
  /deep/ .van-button--default{
    color: #000922;
    background: #FFC72B;
    font-size: torem(16);
    border-radius: torem(4);
    width: 100%;
  }
  .service{
    width: 100%;
    margin-bottom: torem(8);
    display: flex;
    align-items: flex-start;
    text-align: start;
    font-size: torem(12);
    color: #000922;
    line-height: 1.5;
    .checkIcon{
      width: torem(16);
      height: torem(16);
    }
    div{
      text-align: start;
      width: 95%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/compontents/freeZone/createSymbol/thirdStep.vue